/**
 * Part F global behaviour — scan-to-validate audio feedback.
 *
 *   success     → 800 Hz, 100 ms
 *   error       → 300 Hz, 200 ms
 *   wrongProduct→ 300 Hz, 500 ms + vibrate
 *
 * Web Audio API is created lazily on the first call so we don't trip the
 * browser auto-play policy on app boot.
 */
let ctx: AudioContext | null = null;
function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Ctor: any = (window as any).AudioContext || (window as any).webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  return ctx;
}

function beep(freqHz: number, durationMs: number): void {
  const c = getCtx();
  if (!c) return;
  const t0 = c.currentTime;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freqHz;
  // Short attack/release to avoid clicks.
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(0.5, t0 + 0.005);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + durationMs / 1000);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + durationMs / 1000 + 0.02);
}

export function useAudioFeedback() {
  return {
    success: () => beep(800, 100),
    error: () => beep(300, 200),
    wrongProduct: () => {
      beep(300, 500);
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        navigator.vibrate([200, 80, 200]);
      }
    },
  };
}
